import React, { useState, useRef, useEffect } from 'react';

const Dropdown = ({
  name,
  label,
  value,
  options = [],
  onChange,
  placeholder = 'Select an option',
  className = '',
  disabled = false,
  required = false,
  invalid = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelect = (optionValue) => {
    if (onChange) {
      const syntheticEvent = {
        target: {
          name: name,
          value: optionValue,
        },
      };
      onChange(syntheticEvent);
    }
    setIsOpen(false);
  };

  const selectedOption = options.find(opt => 
    (typeof opt === 'string' ? opt : opt.value) === value
  );
  const displayValue = selectedOption 
    ? (typeof selectedOption === 'string' ? selectedOption : selectedOption.label)
    : '';

  return (
    <div className={`dropdown-wrapper ${className}`.trim()} ref={dropdownRef}>
      {label && (
        <label className="dropdown-label">
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      <div className="dropdown-container">
        <div
          className={`dropdown-input ${isOpen ? 'dropdown-input-open' : ''} ${disabled ? 'dropdown-input-disabled' : ''} ${invalid ? 'dropdown-input-invalid' : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <input
            type="text"
            name={name}
            value={displayValue}
            readOnly
            placeholder={placeholder}
            disabled={disabled}
            className="dropdown-input-field"
          />
          <svg
            className={`dropdown-arrow ${isOpen ? 'dropdown-arrow-open' : ''}`}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {isOpen && (
          <div className="dropdown-menu">
            {options.length === 0 ? (
              <div className="dropdown-option dropdown-option-empty">No options available</div>
            ) : (
              options.map((option, index) => {
                const optionValue = typeof option === 'string' ? option : option.value;
                const optionLabel = typeof option === 'string' ? option : option.label;
                const isSelected = value === optionValue;

                return (
                  <div
                    key={index}
                    className={`dropdown-option ${isSelected ? 'dropdown-option-selected' : ''}`}
                    onClick={() => handleSelect(optionValue)}
                  >
                    {optionLabel}
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
